<template>
	<div class="pt-0 mb-0 guest-ui">
		<!-- <h3 class="mb-0">Guests</h3> -->
		<transition name="slide-vertical">
			<hgroup
				class="flex mb-2"
				v-if="
					!isPrivateTour &&
						!enableRateDuration &&
						!isPackage &&
						!DisableLargeGroup
				"
			>
				<div class="mb-0">
					<p style="font-weight: 500;" class="mb-0 mt-0">
						I need more than {{ maxPeople }}
						{{
							activeProductDetails.OverrideRateLabel
								? maxPeople == 1
									? activeProductDetails.RateLabelSingular
									: activeProductDetails.RateLabelPlural
								: maxPeople != 1
								? 'guests'
								: 'guest'
						}}
						<br />
						<small v-if="!isPackage && !DisableLargeGroup" class="text-pencil"
							>Book over multiple time slots</small
						>
					</p>
				</div>
				<div v-if="!isPackage && !DisableLargeGroup">
					<toggle
						:name="'IsLargeGroup_toggle'"
						v-model="activeProductDetails.IsLargeGroup"
					/>
				</div>
			</hgroup>
		</transition>

		<pre>totalGuestInActivity: {{ totalGuestInActivity }}</pre>
		<pre>totalGuestInPackage: {{ totalGuestInPackage }}</pre>

		<router-link
			:disabled="disabled"
			v-show="!IsLargeGroup && !enableRateDuration"
			class="button large _shadow outline mb-2"
			:class="{
				'bg-mist': totalGuestInActivity,
				'scale-animation': !totalGuestInActivity,
				'border-red':
					totalGuestInActivity != totalGuestInPackage &&
					totalGuestInActivity &&
					isPackage &&
					!isPrivateTour,
			}"
			:to="disabled ? '#' : 'guests/' + entityHierarchyKey"
			activeClass="active"
		>
			<span class="flex" v-if="totalGuestInActivity">
				<span class="-text-medium">
					{{ totalGuestInActivity }}
					<span
						v-if="
							totalGuestInActivity != totalGuestInPackage &&
								isPackage &&
								!isPrivateTour
						"
						>of {{ totalGuestInPackage }}</span
					>
					{{
						activeProductDetails.OverrideRateLabel
							? totalGuestInActivity == 1
								? activeProductDetails.RateLabelSingular
								: activeProductDetails.RateLabelPlural
							: totalGuestInActivity != 1
							? 'guests'
							: 'guest'
					}}
				</span>
				<small class="text-blue">Edit</small>
			</span>
			<span class="text-blue" v-else
				>{{ isPackage ? 'Assign ' : 'Add ' }}
				{{
					activeProductDetails.OverrideRateLabel
						? activeProductDetails.RateLabelPlural
						: 'guests'
				}}</span
			>
		</router-link>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex';

	export default {
		name: 'GuestUI',
		props: [
			'maxPeople',
			'entityHierarchyKey',
			'totalGuestInPackage',
			'totalGuestInActivity',
			'isPackage',
			'IsLargeGroup',
			'DisableLargeGroup',
			'isPrivateTour',
			'enableRateDuration',
			'disabled',
			// "activity",
			// "complete"
		],
		data: function() {
			return {
				textVal: false,
			};
		},
		created() {
			console.log(disabled);
		},
		computed: {
			...mapGetters(['activeProductDetails']),
			path() {
				return this.$route.params.client;
			},
		},
		methods: {
			//...mapMutations(["updateIsLargeGroup"])
		},
	};
</script>

<style></style>
